<template>
  <SideMenu
    :title="sideMenuData.title"
    :side-menu-width="sideMenuData.contentWidth"
    :value="isTopDialog(componentName)"
    :z-index="210"
    side-menu-auto-scroll-y
    side-menu-is-block
    @side-menu:click-close="handleDialogClose"
  >
    <template #titleIcon>
      <img
        src="/static/_v1/pd/icons/ui-kit/club/club-percent.svg"
        class="ml-1"
        width="24"
        height="24"
        alt="Иконка Процент Клуба"
      >
    </template>
    <ClubDesktopInfoModalContent
      class="pa-6"
      :pdf-data="pdfData"
    />
  </SideMenu>
</template>

<script>
import vuetify from 'www/modules/vuetify-plugin'
import { ClubEventsNames } from 'www/vue_components/common/Club/mixins'
import SideMenu from 'www/vue_components/desktop/core/SideMenu.vue'
import DialogManager from 'www/vue_components/common/mixins/DialogManager'
import ClubInfoModalLogic from 'www/vue_components/common/Club/components/dependencies/ClubInfoModal/mixins/ClubInfoModalLogic'
import ClubDesktopInfoModalContent from 'www/vue_components/desktop/Club/components/dependencies/ClubDesktopInfoModal/ClubDesktopInfoModalContent.vue'
import ClubInfoModalExpansionPanel from 'www/vue_components/common/Club/components/dependencies/ClubInfoModal/mixins/ClubInfoModalExpansionPanel'

export default {
  name: 'ClubDesktopInfoModal',
  vuetify,
  components: {
    SideMenu,
    ClubDesktopInfoModalContent,
  },
  mixins: [
    DialogManager,
    ClubEventsNames,
    ClubInfoModalLogic,
    ClubInfoModalExpansionPanel,
  ],
  mounted() {
    window.addEventListener(this.eventClubSelectInfoModal, this.handleSelectInfoModal)
  },
}
</script>
